<script setup lang="ts">
  import { computed } from 'vue';

  interface Props {
    total: number;
    scope: 'matrix' | 'sheet' | 'permissions';
  }

  const props = defineProps<Props>();

  const COUNT_RULES = {
    matrix: 'Campos preenchíveis da matriz. Textos fixos, títulos e tabelas não contam.',
    permissions:
      'Campos preenchíveis e tabelas da matriz. Cada tabela conta como 1, além dos campos dentro dela.',
    sheet: 'Campos preenchíveis que você vê, inclusive nas linhas novas. Campos escondidos não contam.',
  } as const;

  const tooltipOptions = computed(() => ({
    content: COUNT_RULES[props.scope],
    placement: 'top' as const,
    theme: 'custom',
    trigger: 'mouseenter focus',
    hideOnClick: true,
    offset: [0, 8] as [number, number],
  }));
</script>

<template>
  <span
    v-tippy="tooltipOptions"
    tabindex="0"
    class="whitespace-nowrap rounded-sm font-[var(--font-base)] text-xs text-[var(--color-gray-07)] focus:outline-none focus:ring-1 focus:ring-[var(--theme-secondary-ink)]"
    data-testid="total-field-count"
  >
    Nº total de campos: {{ props.total }}
  </span>
</template>
